import { useEffect } from "react";

import { useGetStationList } from "../../hooks";
import { getCachedItem, setCachedItem } from "../../helpers";

let hydrated = false;

export const useStationListWithCache = () => {
  const cachedData = hydrated ? getCachedItem("stations") : false;
  const { data, isLoading, isSuccess } = useGetStationList(!cachedData);
  const stations = cachedData || data || [];

  useEffect(() => {
    if (data && isSuccess) {
      hydrated = true;
      setCachedItem("stations", data);
    }
  }, [data, isSuccess]);

  return { stations, isLoading, isSuccess };
};
